import React from 'react';
import { motion } from 'framer-motion';

const Loading = ({ darkMode = false }) => {
  return (
    <div className={`fixed inset-0 z-50 flex flex-col items-center justify-center ${darkMode ? 'bg-slate-900' : 'bg-white'}`}>
      
      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative mb-10"
      >
        {/* Soft glow behind logo */}
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
            opacity: [0.2, 0.4, 0.2]
          }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
          className={`absolute inset-0 -z-10 rounded-full blur-3xl ${darkMode ? 'bg-slate-600' : 'bg-slate-200'}`}
          style={{ width: '130%', height: '130%', left: '-15%', top: '-15%' }}
        />

        <img
          src="https://res.cloudinary.com/dpymwa41m/image/upload/v1772402777/unnamed_e0vbb4-removebg-preview_kxmvcm.png"
          alt="Rev Peter Kyengo Logo"
          className="w-48 h-48 md:w-64 md:h-64 object-contain drop-shadow-xl"
        />
      </motion.div>

      {/* Name */}
      <motion.h2
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className={`text-2xl md:text-3xl font-medium mb-10 ${darkMode ? 'text-white' : 'text-slate-900'}`}
      >
        Rev Peter Kyengo
      </motion.h2>

      {/* Dots only */}
      <div className="flex space-x-2">
        {[0, 1, 2, 3, 4].map((index) => (
          <motion.div
            key={index}
            animate={{
              scale: [1, 1.4, 1],
              opacity: [0.3, 1, 0.3]
            }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              delay: index * 0.15,
              ease: "easeInOut"
            }}
            className={`w-2 h-2 rounded-full ${darkMode ? 'bg-white' : 'bg-slate-900'}`}
          />
        ))}
      </div>

    </div>
  );
};

export default Loading;